import { Injectable } from '@angular/core';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Injectable({
  providedIn: 'root'
})
export class FontPreloaderService extends SafariInjector {
  constructor() {
    super();
  }
  preloadFonts(): Promise<void> {
    // These fonts are the sole source for their weights — there are no
    // corresponding @font-face entries in safari-fonts.scss. Adding CSS
    // entries for the same weights causes conflicting mappings and FOUT.
    const fonts = [
      {
        family: 'Open Sans',
        src: "url('fonts/OpenSans-Semibold.woff2') format('woff2')",
        options: {
          weight: '500',
          style: 'normal'
        }
      },
      {
        family: 'Open Sans',
        src: "url('fonts/OpenSans-Semibold.woff2') format('woff2')",
        options: {
          weight: '600',
          style: 'normal'
        }
      },
      {
        family: 'Open Sans',
        src: "url('fonts/OpenSans-Bold.woff2') format('woff2')",
        options: {
          weight: '700',
          style: 'normal'
        }
      },
      {
        family: 'safdings',
        src: "url('fonts/safdings.woff') format('woff')",
        options: {
          weight: 'normal',
          style: 'normal'
        }
      }
    ];
    if (this.isPlatformBrowser) {
      const promises = fonts.map(({ family, src, options }) => {
        const font = new FontFace(family, src, options);
        return (
          font
            .load()
            .then(() => (this.document.fonts as any).add(font))
            // eslint-disable-next-line no-console -- can't see any reason to have an error while loading bundled fonts but keeping a simpe console.error here for now
            .catch(err => console.error(err))
        );
      });
      return Promise.all(promises).then(() => {});
    }
    return Promise.resolve();
  }
}
